import { render, staticRenderFns } from "./ChannelSettings.vue?vue&type=template&id=7bba5aa2&scoped=true&"
import script from "./ChannelSettings.vue?vue&type=script&lang=js&"
export * from "./ChannelSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSettings.vue?vue&type=style&index=0&id=7bba5aa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba5aa2",
  null
  
)

export default component.exports